/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_5_DescInputs */

const es_home_nexy_feature_5_desc = /** @type {(inputs: Home_Nexy_Feature_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicita resúmenes, extracción de datos específicos o comparativas entre versiones.`)
};

const en_home_nexy_feature_5_desc = /** @type {(inputs: Home_Nexy_Feature_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request summaries, specific data extraction, or version comparisons.`)
};

/**
* | output |
* | --- |
* | "Request summaries, specific data extraction, or version comparisons." |
*
* @param {Home_Nexy_Feature_5_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_5_desc = /** @type {((inputs?: Home_Nexy_Feature_5_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_5_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_5_desc(inputs)
	return en_home_nexy_feature_5_desc(inputs)
});
export { home_nexy_feature_5_desc as "home.nexy.feature_5_desc" }